import { Card, Image, Spinner } from '@heroui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Placeholder from '@/assets/images/placeholder.png';

interface ThreadPlaceholderProps {
  count: number;
  isLoading: boolean;
  error: unknown;
}

export function ThreadPlaceholder({
  count,
  isLoading,
  error,
}: ThreadPlaceholderProps) {
  const { t } = useTranslation('inbox');

  const description = useMemo(() => {
    if (error) {
      return (
        <Card className="bg-danger-100 m-4 w-3/4" radius="sm" shadow="none">
          <p className="m-4 text-danger-900 text-sm">{t('thread.error')}</p>
        </Card>
      );
    }

    if (isLoading) {
      return <Spinner label={t('common.text.loading')} color="primary" />;
    }

    return (
      <>
        <p className="text-xl">{t('threadplaceholder.title', { count })}</p>
        <p className="font-light">{t('threadplaceholder.description')}</p>
      </>
    );
  }, [count, error, isLoading]);

  return (
    <>
      <Image src={Placeholder} width={350} disableSkeleton />
      {description}
    </>
  );
}
